import { render, staticRenderFns } from "./hero-multiple.vue?vue&type=template&id=ffb4a878"
import script from "./hero-multiple.vue?vue&type=script&lang=js"
export * from "./hero-multiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports